module.exports = __webpack_public_path__ + "assets/img/Amazon.1bfe3888.png";